import React, { useEffect, useState } from "react";
import Header from "../shared/Header/Header";
import Table from "./Table";
import httpClient from "../../lib/HttpClient";

import InfoIcon from "../../images/icons/svg/info-tooltip-active.svg";
import DownloadIcon from "../../images/icons/svg/download-green.svg";
import OopsImage from "../../images/icons/svg/oops-image.svg";
import { UikButton } from "@uik";
import download from "downloadjs";

import styles from "./AuditView.module.scss";

const DEFAULT_SORT = { column: "upload_date", direction: "desc" };

export default () => {
  // Sorting is done by the server; this is only what we ask it for.
  const [sort, setSort] = useState(DEFAULT_SORT);
  const [audit, setAudit] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // A newer request (or leaving the page) makes this one stale, so its
    // response must not replace what the newer one shows.
    let stale = false;

    httpClient
      .post("/documents/drafts/all.json", { sort })
      .then((response) => {
        if (stale) return;
        setError(null);
        setAudit({
          columns: response.data.columns,
          documents: response.data.documents,
        });
      })
      .catch((err) => {
        if (stale) return;
        // The API answers 404 to users who are not admins.
        const status = err && err.response && err.response.status;
        setError(status === 404 || status === 403 ? "forbidden" : "failed");
      });

    return () => {
      stale = true;
    };
  }, [sort]);

  const downloadCSV = () => {
    httpClient
      .post("/documents/drafts/all/csv.json", { sort })
      .then((response) => {
        download(response.data, `Audit-View.csv`, "text/csv");
      });
  };

  const sortBy = (column) => {
    setSort((current) => ({
      column,
      direction:
        current.column === column && current.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  const columns = audit && audit.columns;
  const documents = audit && audit.documents;

  const openDraft = (id) => {
    window.open(`${window.location.origin}/drafts/${id}`, "_blank");
  };

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.body}>
        <div className={styles.headerContainer}>
          <div className={styles.titleContainer}>
            <div className={styles.title}>Audit View</div>
            <div className={styles.description}>
              All the draft content in your workspace.
            </div>
          </div>
          <div className={styles.downloadLinkContainer}>
            <UikButton
              className={styles.exportButton}
              onClick={() => {
                downloadCSV();
              }}
            >
              Download
              <img className={styles.externalLink} src={DownloadIcon} />
            </UikButton>
          </div>
        </div>
        {error === "failed" && (
          <div className={styles.emptyState}>
            <div className={styles.infoIcon}>
              <img src={InfoIcon} />
            </div>
            <div className={styles.text}>
              The draft content could not be loaded. Please try again.
            </div>
          </div>
        )}
        {error !== "forbidden" && documents && documents.length > 0 && (
          <div className={styles.table}>
            <Table
              columns={columns}
              rows={documents}
              sort={sort}
              onSort={sortBy}
              openDraft={openDraft}
            />
          </div>
        )}
        {error !== "forbidden" && documents && documents.length === 0 && (
          <div className={styles.emptyState}>
            <div className={styles.infoIcon}>
              <img src={InfoIcon} />
            </div>
            <div className={styles.text}>
              There is no draft content in your workspace
            </div>
          </div>
        )}
        {error === "forbidden" && (
          <div className={styles.unauthorizedState}>
            <div className={styles.text}>
              <div className={styles.header}>oops!</div>
              <div className={styles.text1}>
                Looks like you don't have permission to view this page
              </div>
              <div className={styles.text2}>
                Please ask your workspace admin to grant you permissions
              </div>
            </div>
            <div className={styles.image}>
              <img src={OopsImage} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
